module.exports = __webpack_public_path__ + "static/scale-model-of-addison-circle-park-in-plano-texas-c65f71b6c8c9f2a62497c90d5c16562d.png";